module.exports = __webpack_public_path__ + "static/media/Coach_x_Disney.ffa5b6a3.gif";